import { ProjectDataObject } from '../../models/Projects/projectsLibrary';
import { IEditProjectPUT } from 'cd-eft/models/Projects/editProject';
import stores from 'cd-eft/models/Stores';
import * as PRJAPI from 'cd-eft/services/eftPrjAdminApi';

const AppStore = stores.AppStore;
const username = localStorage.getItem('username');

export async function updateProject(project: ProjectDataObject): Promise<void> {
  // Update the projectApplicationUser with logged in user to make sure lastChangedBy field is updated
  // Check if userName is in userProfileStore
  if (AppStore.userProfileStore.userName) {
    project.lastChangedBy = AppStore.userProfileStore.userName;
    // If not, then check localStorage
  } else if (username) {
    project.lastChangedBy = username;
  }

  const putJSON: IEditProjectPUT = {
    projectUuid: project.projectUuid,
    lastChangedBy: project.lastChangedBy,
    projectClassId: project.projectClassId,
    projectTitle: project.projectTitle,
    projectStatusTypeId: 1,
    srid: 0,
    zUnits: 0,
    xmin: 0,
    xmax: 0,
    ymin: 0,
    ymax: 0,
  };

  await PRJAPI.EftProjectController.updateProjectUsingPOST(putJSON);
}
